import { Alert, Heading, Link, Text } from "@chakra-ui/react";
import { PopularRecommendations } from "../components/PopularRecommendations";

export function Home() {
  return (
    <>
      <Heading as="h1" size="4xl" mb={4}>
        Everything is Everything!
      </Heading>
      <Alert.Root status="info" title="First time here?">
        <Alert.Indicator />
        <Alert.Title>
          New here? Check out{" "}
          <Link href="https://x.com/diwakergupta/status/1973370366702633140">
            this thread
          </Link>{" "}
          for an overview of the features!
        </Alert.Title>
      </Alert.Root>
      <Text fontSize="lg" mb={6}>
        You can browse, search and explore recommendations from the YouTube show{" "}
        <Link colorPalette="cyan" href="https://www.youtube.com/amitvarma">
          Everything is Everything
        </Link>
        . Select an episode to see its recommendations, or explore popular ones.
      </Text>
      <Text>
        Each link has been "enriched" with 3-5 topics and a brief description
        (using LLMs).
      </Text>
      <PopularRecommendations />
    </>
  );
}
